import { type Endpoint } from "@mongez/http";
import type { GenericObject } from "@mongez/reinforcements";

export async function getRegionsService(endpoint: Endpoint) {
  const response = await endpoint.get("/regions");

  return response.data.regions;
}

export async function getCitiesService(
  endpoint: Endpoint,
  params: GenericObject = {},
) {
  const response = await endpoint.get("/cities", {
    params,
  });

  return response.data.cities;
}

export async function getZipCodesService(
  endpoint: Endpoint,
  params: GenericObject = {},
) {
  const response = await endpoint.get("/zip-codes", {
    params,
  });

  return response.data.zipCodes;
}

export async function getDistrictsService(
  endpoint: Endpoint,
  params: GenericObject = {},
) {
  const response = await endpoint.get("/districts", {
    params,
  });

  return response.data.districts;
}

export async function getOrderRequestOptionsService(endpoint: Endpoint) {
  const response = await endpoint.get("/order-requests/options");

  return response.data;
}

export async function createOrderRequestService(endpoint: Endpoint, data: any) {
  const response = await endpoint.post("/order-requests", data);

  return response.data;
}
